import AmountFormat from '~components/i18n/amount-format';
import { getDiscount, Tier } from '~services/business/pricing';
import { Currency } from '~services/i18n/currency';
import { Trans } from '@lingui/macro';
import styled from 'styled-components';
import { theme } from '~globalStyles';
import { PricingPlanComponentsProps } from '~components/pricing/types';

type SavingsInfoProps = PricingPlanComponentsProps;

export const SavingsInfo = ({ currency, language, tier }: SavingsInfoProps) => {
    return (
        <Savings>
            <Trans id="global.pricing.priceTable.premium.price.yearly.savings" />{' '}
            <AmountFormat
                noSign
                textColor="inherit"
                amount={getDiscount(tier, currency, true)}
                currencyEnum={currency}
                language={language}
            />
        </Savings>
    );
};

const Savings = styled.div`
    background: ${theme.darkPurple};
    border-radius: 5px;
    padding: 5px;
    width: fit-content;
    font-weight: 500;
    font-size: 12px;
    line-height: 14px;
    color: ${({ theme }) => theme.lightPurple};
    position: absolute;
    left: 0;
    top: -1.5rem;
`;
